import React, {useState, useEffect} from "react";
import { GetBannerByIdData} from "../../../lib/data";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";
import EditBannersUi from "../../../ui/bannersUi/editBannersUi";

export default function EditBanners () {

    const [bannerData, setbannerData] = useState({});
    const {bannerId} = useParams();
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const bannerData = await GetBannerByIdData(bannerId);
        setbannerData({});
        setbannerData(bannerData.data);
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.banner")}</h1>
                <EditBannersUi bannerData={bannerData} />
            </div>
        </div>
    );
};